export const recargarPagina = () => {
    window.location.replace(window.location.origin);
}

export const isProduction = () => {
    return window.origin.indexOf('localhost') === -1;
}

export const updateTableKeysLocalStorage = (key, data) => {
    const tablas = JSON.parse(localStorage.getItem("LA-CAJA-BOBA")) || {};
    tablas[key] = data;
    localStorage.setItem('LA-CAJA-BOBA', JSON.stringify(tablas));
}


export const getTableKeysLocalStorage = (key) => {
    const tablas = JSON.parse(localStorage.getItem("LA-CAJA-BOBA")) || {};
    const data = tablas[key] || null;
    return data;
}

export const notifyMe = (msg) => {
    fetch(`https://lu4ult-api.vercel.app/notifications/tnss?msg=${encodeURIComponent(msg)}`)
        .then(rtta => rtta.text())
        .then(response => {
            console.log(response)
        })
        .catch(e => console.log(e))
}

export const extractYoutubeId = (url) => {
    url = url.trim();

    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url;
    }

    try {
        const urlObj = new URL(url);
        const hostname = urlObj.hostname.replace('www.', '');

        if (!hostname.includes('youtube.com') && !hostname.includes('youtu.be')) {
            return null;
        }

        if (hostname === 'youtu.be') {
            return urlObj.pathname.slice(1).split('?')[0];
        }

        if (urlObj.pathname === '/watch') {
            return urlObj.searchParams.get('v');
        }

        if (urlObj.pathname.startsWith('/live/')) {
            return urlObj.pathname.split('/')[2].split('?')[0];
        }

        if (urlObj.pathname.startsWith('/embed/')) {
            return urlObj.pathname.split('/')[2].split('?')[0];
        }

        if (urlObj.pathname.startsWith('/v/')) {
            return urlObj.pathname.split('/')[2].split('?')[0];
        }

        return null;
    } catch (e) {
        return null;
    }
};

//FCM
export const isMobile = () => {
    return window.innerWidth < 500;
}


export async function getGeolocationPermissionState() {
    if (!navigator.permissions) return 'unsupported';

    try {
        const result = await navigator.permissions.query({ name: 'geolocation' });
        return result.state; // 'granted' | 'prompt' | 'denied'
    } catch {
        return 'unsupported';
    }
}



export const getSOFromDevice = () => {
    if (window.navigator.userAgent.indexOf("Windows NT 10.0") !== -1) {
        return "Windows 10";
    }

    if (window.navigator.userAgent.indexOf("Windows NT 6.3") !== -1) {
        return "Windows 8.1";
    }

    if (window.navigator.userAgent.indexOf("Windows NT 6.2") !== -1) {
        return "Windows 8";
    }

    if (window.navigator.userAgent.indexOf("Windows NT 6.1") !== -1) {
        return "Windows 7";
    }

    if (window.navigator.userAgent.indexOf("Windows NT 6.0") !== -1) {
        return "Windows Vista";
    }

    if (window.navigator.userAgent.indexOf("Windows NT 5.1") !== -1) {
        return "Windows XP";
    }

    if (window.navigator.userAgent.indexOf("Windows NT 5.0") !== -1) {
        return "Windows 2000";
    }

    if (window.navigator.userAgent.indexOf("Mac") !== -1) {
        return "Mac/iOS";
    }

    if (window.navigator.userAgent.indexOf("X11") !== -1) {
        return "UNIX";
    }

    if (window.navigator.userAgent.indexOf("Linux") !== -1) {
        if (window.innerWidth < 600) {
            return "Android";
        }
        return "Linux";
    }
}


export function getBrowserType() {
    const test = regexp => {
        return regexp.test(navigator.userAgent);
    };

    if (test(/opr\//i) || !!window.opr) {
        return 'Opera';
    } else if (test(/edg/i)) {
        return 'Edge';
    } else if (test(/chrome|chromium|crios/i)) {
        return 'Chrome';
    } else if (test(/firefox|fxios/i)) {
        return 'Firefox';
    } else if (test(/safari/i)) {
        return 'Apple Safari';
    } else if (test(/trident/i)) {
        return 'Microsoft Internet Explorer';
    } else if (test(/ucbrowser/i)) {
        return 'UC Browser';
    } else if (test(/samsungbrowser/i)) {
        return 'Samsung Browser';
    } else {
        return 'Unknown';
    }
}



const parseFechaLocal = (str) => {
    const [year, month, day] = str.split('-').map(Number);
    return new Date(year, month - 1, day); // month empieza en 0
};

export const fechaConFormato = (data, formato) => {
    //Cuando recibimos 2025-05-17 (es decir date.split("T")[0]), para evitar conflictos con el time zone,
    //lo manejamos así, construyendo el objeto Date con la función auxiliar de arriba.
    if (typeof data === 'string' && data.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
        data = parseFechaLocal(data);
    }

    const date = new Date(data);
    if (isNaN(date)) return 'Fecha inválida';

    //Hora
    const h = date.getHours();
    const xh = h < 10 ? '0' + h : h;
    const min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    const ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

    formato = formato.replace('hh', h);
    formato = formato.replace('xh', xh);
    formato = formato.replace(':mm', ':' + min);
    formato = formato.replace('ss', ss);

    //Fecha
    const dd = date.getDate();
    const xd = dd < 10 ? '0' + dd : dd;
    const mm = 1 + date.getMonth();
    const xm = mm < 10 ? '0' + mm : mm;
    const yy = date.getFullYear() - 2000;
    const yyyy = date.getFullYear();

    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const dddd = days[date.getDay()];

    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    const mmmm = months[date.getMonth()]

    formato = formato.replace('dddd', dddd);
    formato = formato.replace('xd', xd);
    formato = formato.replace('dd', dd);
    formato = formato.replace('mmmm', mmmm);
    formato = formato.replace('xm', xm);
    formato = formato.replace('mm', mm);
    formato = formato.replace('yyyy', yyyy);
    formato = formato.replace('yy', yy);

    return formato;
}

export const tiempoActivoFormateado = (tiempo) => {

    if (tiempo === 0)
        return '-';

    if (tiempo < 10)
        return `0:0${tiempo}`;

    if (tiempo < 60)
        return `0:${tiempo}`;

    let horas = parseInt(tiempo / 60);
    let minutos = tiempo - horas * 60;

    return `${horas}:${minutos < 10 ? 0 : ''}${minutos}`;
}

export const haceCuantoTiempoStr = (fecha1, fecha2) => {
    //Si pasaron sólo una fecha hay que comparar con la hora actual.
    if (typeof (fecha1) === 'object' && fecha2 === undefined) {
        fecha2 = fecha1;
        fecha1 = new Date();
    }

    if (typeof (fecha1) !== 'object')
        return 'fecha 1 no es objeto';

    if (typeof (fecha2) !== 'object')
        return 'fecha 2 no es objeto';

    const esFuturoOPasado = fecha1 < fecha2 ? 'En' : 'Hace';
    const diferenciaTiempoMinutos = parseInt(Math.abs((fecha1 - fecha2)) / 60000);

    if (diferenciaTiempoMinutos > 3 * 24 * 60)
        return `${esFuturoOPasado} ${parseInt(diferenciaTiempoMinutos / (24 * 60))} días`;

    const txt = diferenciaTiempoMinutos === 0 ? 'Ahora' : diferenciaTiempoMinutos >= 60 ? `${esFuturoOPasado} ${parseInt(diferenciaTiempoMinutos / 60)} hora${parseInt(diferenciaTiempoMinutos / 60) > 1 ? 's' : ''}` : `${esFuturoOPasado} ${diferenciaTiempoMinutos} minuto${diferenciaTiempoMinutos > 1 ? 's' : ''}`;
    return txt;
}